export enum AsideTab {
  RESOURCES = "resources",
  INSIGHTS = "insights",
  EVENT = "event",
}
